(function () {
  'use strict';

  // Shopify theme-editor re-init guard.
  // Extend with custom observer logic if needed in future phases.
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      if (!event.target.querySelector('[id^="rf-fa-"]')) return;
      // Re-init observers here if added later.
    });
  }
})();
